export class LeadModel {
  public id?: string = '';
  public name: string = '';
  public cpf: string = '';
  public email?: string = '';
  public phone: string = '';
  public origin?: string = '';
}
